module.exports = __webpack_public_path__ + "static/media/soul-learning-path-navigation-active.68ed9f8b.svg";